import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DeviceInstalledApplicationsStatusEffects } from './device-installed-applications.effects';
import { deviceInstalledApplicationsReducer } from './device-installed-applications.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('device-installed-applications', deviceInstalledApplicationsReducer),
    EffectsModule.forFeature([DeviceInstalledApplicationsStatusEffects]),
  ],
  providers: [],
})
export class DeviceInstalledApplicationsStoreModule {}
